import React, { Component } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import { Growl } from 'primereact/growl';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import servicioHttp from '../servicio/ServicioHttp';
import { Dropdown } from 'primereact/dropdown';
import servicioObjetos from '../servicio/ServicioObjetos';
import ServicioArchivos from '../servicio/ServicioArchivos';

const PAGINACION_INICIAL = {
    registrosPorPagina: 10,
    registrosTotales: 0,
    join: null,
    restriccionesDinamicas: [
    ]
}
const TODOS = { label: "Todos", value: 0 };
const JOIN_PRINCIPAL = {
    "ttPatron": "alias_ttPatron"

};
export class BuscarPatron extends Component {

    constructor() {
        super();
        this.state = {

            estatus: [{ label: "Activo", value: 0 }, { label: "Inactivo", value: 1 }],
            criterioBusqueda: [{ label: "Todos", value: "Todos" }],
            patron: {},
            error: {},
            paginacion: PAGINACION_INICIAL,
            idsenube: 0,
            rfcEmpresas: [],
            registrosPatronales: [],

        }
    }
    componentDidMount() {
        this.obtenerRfcEmpresa();
    }

    obtenerRfcEmpresa = () => {
        servicioHttp.consumirPostHttp('/patron/obtener_rfc.json').then(response => {
            // this.setState({ rfcEmpresas: response.data.lista });
            let rfcEmpresas = [TODOS];
            var newArray = rfcEmpresas.concat(response.data.lista);
            let { patron } = this.state;
            patron.rfc = TODOS;
            this.setState({ rfcEmpresas: newArray, patron });

        }).catch(error => {
        });
    }

    obtenerRegistroPatronal = () => {
        let { patron } = this.state;
        let patronEnvio = {};
        patronEnvio.id = patron.rfc.value;
        servicioHttp.consumirPostHttp('/registropatronal/obtener_registro_patronal.json', patronEnvio).then(response => {
            let registrosPatronales = [TODOS];
            var newArray = registrosPatronales.concat(response.data.lista);
            let { patron } = this.state;
            patron.registroPatronal = TODOS;
            this.setState({ registrosPatronales: newArray, patron });


        }).catch(error => {
        });
    }
    obtenerRP = (e, mayusculas) => {
        this.asignarValores(e, mayusculas);
        this.obtenerRegistroPatronal();
    }

    obtnerRegistrosPatronales = () => {
        let { paginacion, patron } = this.state;
        paginacion.join = JOIN_PRINCIPAL;
        paginacion.restriccionesDinamicas = [];
        if (!servicioObjetos.esObjetoVacio(patron.registroPatronal)) {
            if (patron.registroPatronal.value !== 0) {
                paginacion.restriccionesDinamicas.push({

                    tipoRestriccion: "eq",
                    nombrePropiedad: "id",
                    valorPropiedad: patron.registroPatronal.value
                });
            }
        }
        if (!servicioObjetos.esObjetoVacio(patron.rfc)) {

            if (patron.rfc.value !== 0) {
                paginacion.restriccionesDinamicas.push({
                    tipoRestriccion: "eq",
                    nombrePropiedad: "alias_ttPatron.id",
                    valorPropiedad: patron.rfc.value

                });
            }
        }
        if (!servicioObjetos.esObjetoVacio(patron.nombre)) {
            paginacion.restriccionesDinamicas.push({

                tipoRestriccion: "eq",
                nombrePropiedad: "alias_ttPatron.nombre",
                valorPropiedad: patron.nombre

            });
        }
        if (!servicioObjetos.esObjetoVacio(patron.nombreRepresentanteLegal)) {
            paginacion.restriccionesDinamicas.push({

                tipoRestriccion: "eq",
                nombrePropiedad: "alias_ttPatron.nombreRepresentanteLegal",
                valorPropiedad: patron.nombreRepresentanteLegal
            });

        }
        if (!servicioObjetos.esObjetoVacio(patron.actividadEconomica)) {
            paginacion.restriccionesDinamicas.push({

                tipoRestriccion: "eq",
                nombrePropiedad: "alias_ttPatron.actividadEconomica",
                valorPropiedad: patron.actividadEconomica

            });
        }
        if (!servicioObjetos.esObjetoVacio(patron.estado)) {
            paginacion.restriccionesDinamicas.push({

                tipoRestriccion: "eq",
                nombrePropiedad: "alias_ttPatron.estado",
                valorPropiedad: patron.estado.value

            });
        }

        servicioHttp.consumirPostHttp('/registropatronal/paginacion.json', paginacion).then(response => {
            this.setState({
                paginacion: response.data.objeto
            });
            if(response.data.mensaje!==null){
                this.growl.show({ severity: 'success', summary: 'Aviso', detail: "No se encontrarón datos con los criterios seleccionados.", life: 3000 });  
            }

            
            }).catch(error => {
            this.growl.show({ severity: 'error', summary: 'Error', detail: "Error en el servidor", life: 3000 });
        });
    }
    cambiaPagina = (event) => {
        let { paginacion } = this.state;
        paginacion.numeroPagina = event.page;
        paginacion.registrosPorPagina = event.rows;
        this.setState({ idsenube: event.first });
    }
    asignarValores = (event, mayusculas) => {
        servicioObjetos.asignarAtributosObjeto(event, this, mayusculas);

    };
    columnaEstatus = (objeto) => {
        if (objeto.patronEstado === 0)
            return <p style={{ backgroundColor: '#33ff4c', borderWidth: 1, borderColor: '#000', borderRadius: 12, padding: 8 }}>Activo</p>;
        if (objeto.patronEstado === 1)
            return <p style={{ backgroundColor: '#f008', borderWidth: 1, borderColor: '#000', borderRadius: 12, padding: 8 }}>Inactivo</p>;

    }
    limpiarFormulario = () => {
        this.setState({ patron: {} });
    }
    reporteExcel = () => {
        let { paginacion } = this.state;
        paginacion.join = JOIN_PRINCIPAL;
        ServicioArchivos.descargaArchivo('registropatronal/reporte_excel_registro.json', paginacion);

    }
    reportePdf = () => {
        let { paginacion } = this.state;
        paginacion.join = JOIN_PRINCIPAL;
        ServicioArchivos.descargaArchivo('registropatronal/reporte_pdf_patrones.json', paginacion);

    }
    render() {
        let { registrosPatronales, rfcEmpresas, idsenube, estatus, patron, error, paginacion } = this.state;
        return (<div className="card">
            <Growl ref={(el) => this.growl = el} />
            <div className="p-grid">
                <div className="p-col-12 p-md-3">
                    <label>RFC:</label>
                </div>
                <div className="p-col-12 p-md-3">

                    <Dropdown appendTo={document.body} optionLabel="label" id="patron.rfc" name="patron.rfc" options={rfcEmpresas} value={patron.rfc} onChange={(e) => { this.obtenerRP(e, false) }} autoWidth={false} style={{ width: "90%" }} />
                    {error.rfc ? <div><Message severity="error" text={error.rfc} /></div> : null}

                </div>
                <div className="p-col-12 p-md-3">
                    <label>Registro Patronal:</label>
                </div>
                <div className="p-col-12 p-md-3">
                    <Dropdown optionLabel="label" appendTo={document.body} id="patron.registroPatronal" name="patron.registroPatronal" options={registrosPatronales} value={patron.registroPatronal} onChange={(e) => { this.asignarValores(e, false) }} autoWidth={false} style={{ width: "90%" }} />
                    {error.registroPatronal ? <div><Message severity="error" text={error.registroPatronal} /></div> : null}
                </div>
                <div className="p-col-12 p-md-3">
                    <label>Razon Social:</label>
                </div>
                <div className="p-col-12 p-md-3">
                    <InputText id="patron" name="patron.nombre" placeholder="Razón Social" value={patron.nombre || ""}
                        type="search" style={{ width: "100%" }} onChange={(e) => this.asignarValores(e, true)} />
                    {error.nombre ? <div><Message severity="error" text={error.nombre} /></div> : null}
                </div>
                <div className="p-col-12 p-md-3">
                    <label>Representante Legal:</label>
                </div>
                <div className="p-col-12 p-md-3">
                    <InputText id="patron" name="patron.nombreRepresentanteLegal" placeholder="Representante Legal" value={patron.nombreRepresentanteLegal || ""}
                        type="search" style={{ width: "100%" }} onChange={(e) => this.asignarValores(e, true)} />
                    {error.nombreRepresentanteLegal ? <div><Message severity="error" text={error.nombreRepresentanteLegal} /></div> : null}
                </div>
                <div className="p-col-12 p-md-3">
                    <label>Actividad Economica:</label>
                </div>
                <div className="p-col-12 p-md-3">
                    <InputText id="patron" name="patron.actividadEconomica" placeholder="Actividad Economica" value={patron.actividadEconomica || ""}
                        type="search" style={{ width: "100%" }} onChange={(e) => this.asignarValores(e, true)} />
                    {error.actividadEconomica ? <div><Message severity="error" text={error.actividadEconomica} /></div> : null}
                </div>
                <div className="p-col-12 p-md-3">
                    <label>Estado:</label>
                </div>
                <div className="p-col-12 p-md-3">
                    <Dropdown appendTo={document.body} id="patron.estado" name="patron.estado" optionLabel="label" options={estatus} value={patron.estado}
                        onChange={(e) => this.asignarValores(e, false)} autoWidth={false} style={{ width: "100%" }} className={error.estado ? "p-error" : ""}
                    />
                    {error.estado ? <div><Message severity="error" text={error.estado} /></div> : null}
                </div>
                <div className="p-col-12 p-md-2">
                    <center><Button id="patron.buscar" label="Buscar" icon="pi-md-search" onClick={this.obtnerRegistrosPatronales} style={{ width: "100%" }} /></center>
                </div>
                <div className="p-col-12 p-md-2">
                    <center><Button id="patron.limpiar" label="Limpiar" icon="pi-md-refresh" onClick={this.limpiarFormulario} style={{ width: "100%" }} /></center>
                </div>
                <div className="p-col-12 p-md-12">
                    <DataTable value={paginacion.datos} responsive={true}>
                        <Column header="RFC" field="rfc" autoLayout={true} resizableColumns={true} />
                        <Column header="Razón Social" field="nombre" autoLayout={true} resizableColumns={true} />
                        <Column header="Representate Legal" field="nombreRepresentanteLegal" autoLayout={true} resizableColumns={true} />
                        <Column header="Actividad Economica" field="actividadEconomica" autoLayout={true} resizableColumns={true} />
                        <Column header="Registro Patronal" field="registroPatronal" autoLayout={true} resizableColumns={true} />
                        <Column header="Estatus" body={this.columnaEstatus} autoLayout={true} resizableColumns={true} />
                    </DataTable>
                    <Paginator first={idsenube} rows={paginacion.registrosPorPagina} totalRecords={paginacion.registrosTotales} onPageChange={this.cambiaPagina} rowsPerPageOptions={[10, 20, 40, 60, 80, 100]} template="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown" currentPageReportTemplate={"Total: " + paginacion.registrosTotales + ", Página ({currentPage} de {totalPages})"} />
                </div>
                {paginacion.datos !== null ?
                    <div className="p-col-12 p-md-2">
                        <center><Button id="patron.excel" icon="pi-md-get-app" label="Reporte Excel" onClick={this.reporteExcel} style={{ width: "100%" }} /></center>
                    </div>
                    : null}
                <div className="p-col-12 p-md-2">
                    <center><Button id="patron.pdf" icon="pi-md-get-app" label="Reporte PDF" onClick={this.reportePdf} style={{ width: "100%" }} /></center>
                </div>
            </div>
        </div>);
    }
}